import { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import {
  isDesktopSiteModeOnPhone,
  isPhoneLikeDevice,
  syncPhoneDocumentFlag,
} from '../utils/deviceLayout';

/** Layout mobile efetivo: viewport estreito OU smartphone físico (modo desktop do navegador). */
export function useDeviceLayout() {
  const theme = useTheme();
  const viewportSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const viewportMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const [phoneLike, setPhoneLike] = useState(isPhoneLikeDevice);
  const [desktopModeOnPhone, setDesktopModeOnPhone] = useState(isDesktopSiteModeOnPhone);

  useEffect(() => {
    const sync = () => {
      setPhoneLike(isPhoneLikeDevice());
      setDesktopModeOnPhone(isDesktopSiteModeOnPhone());
      syncPhoneDocumentFlag();
    };
    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    return () => {
      window.removeEventListener('resize', sync);
      window.removeEventListener('orientationchange', sync);
    };
  }, []);

  return {
    isMobileSm: viewportSmDown || phoneLike,
    isMobileMd: viewportMdDown || phoneLike,
    isTabletOrDown: viewportMdDown || phoneLike,
    isPhoneLike: phoneLike,
    desktopModeOnPhone,
  };
}
